/**
* SEO Cards JS
* -----------------------------------------------------------------------------
*
* All the JS for the SEO Cards component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'seo-cards',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init() {
      const component = document.querySelector( this.selector() );
      if ( !component ) return;

      const sliderEl = component.querySelector( '.seo-cards__slider' );
      if ( !sliderEl ) return;

      const splide = new Splide( sliderEl, {
        type: 'loop',
        perPage: 4,
        perMove: 1,
        gap: '32px',
        breakpoints: {
          1024: {
            perPage: 2,
            focus: 'center',
          },
          640: {
            perPage: 1,
            focus: 'center',
          },
        },
        pagination: false,
        arrows: false,
        drag: true,
      } );

      splide.mount();

      const prevBtn = component.querySelector( '.seo-cards__prev' );
      const nextBtn = component.querySelector( '.seo-cards__next' );

      if ( prevBtn ) {
        prevBtn.addEventListener( 'click', ( e ) => {
          e.preventDefault();
          splide.go( splide.index - 1 );
        } );
      }

      if ( nextBtn ) {
        nextBtn.addEventListener( 'click', ( e ) => {
          e.preventDefault();
          splide.go( splide.index + 1 );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'seo-cards', COMPONENT );
} )( app );
